<div class="avatar-look-voice-selector">
  <div class="form-content">
    <ng-content select="[fieldsBefore]"></ng-content>

    <qai-field [label]="appearanceLabel() | transloco">
      <qai-floating-select
        [options]="avatarOptions()"
        [placeholder]="'simulationBuilder.AVATAR_SELECT_PLACEHOLDER' | transloco"
        [placement]="'below-start'"
        [offset]="4"
        [shape]="'rectangle'"
        startIcon="search"
        [value]="selectedAvatar()"
        [disabled]="disabled() || isLoadingAvatars()"
        (selectionChange)="onAvatarSelectionChange($event)"
      ></qai-floating-select>
    </qai-field>

    <ng-content select="[fieldsAfter]"></ng-content>

    @if (showScreenshareSection) {
      <screen-share-section
        [personaId]="personaId()"
        [savingPersona]="savingPersona()"
        [simulationUuid]="simulationUuid()"
        [moduleUuid]="moduleUuid()"
        [isSelfAuthoring]="isSelfAuthoring()"
        [conversePromptManualOverride]="conversePromptManualOverride()"
      />
    }

    <!--
    <qai-field [label]="'simulationBuilder.AVATAR_VOICE_LABEL' | transloco">
      <select
        qai-select
        [disabled]="disabled()"
        [ngModel]="selectedVoice()"
        (ngModelChange)="onVoiceSelectionChange($event)"
      >
        @for (voice of voiceOptions; track voice.value) {
          <option [value]="voice.value">{{ voice.label }}</option>
        }
      </select>
    </qai-field>

    <button
      qai-button
      class="play-voice-preview-button"
      [shape]="'normal'"
      [kind]="'secondary'"
      [size]="'medium'"
      [disabled]="disabled() || !selectedVoice()"
      (click)="onPlayVoicePreview()"
    >
      <qai-icon kind="play-filled" positionStart></qai-icon>
      {{ 'simulationBuilder.PLAY_VOICE_PREVIEW_BUTTON' | transloco }}
    </button>
    -->
  </div>

  <div class="avatar-image">
    <img
      [src]="previewImageUrl() || defaultPlaceholder"
      [alt]="'simulationBuilder.AVATAR_ALT' | transloco"
      [class.placeholder-image]="!previewImageUrl()"
    />
  </div>
</div>
